import React, {useEffect, useState} from "react"
import ReactModal from 'react-modal'
import styles from "./digitaltransformationaboutwrap.css"
import anime from 'animejs/lib/anime.es.js';

const FutureAboutWrap = ( { sponsors, sponsorshipLevel }) => {

    const [learnMoreModalState,setLearnMoreModalState] = useState(false)
    const [animation, setAnimation] = useState()
    const [animationPlayed, setAnimationPlayed] = useState(false)

    const showLearnMoreModal = () => setLearnMoreModalState(true)
    const hideLearnMoreModal = () => setLearnMoreModalState(false)

    const handleScroll = () => {
        let offset = window.document.getElementById("About").getElementsByClassName("date")[0].offsetTop
        let startPoint = offset - window.scrollY
        if( startPoint <= 380 && !animationPlayed){
            // console.log('handling scroll event!')
            animation.play()
            setAnimationPlayed(!animationPlayed)
        }
    }
    useEffect( ()=>{
        // console.log('setAnimation timeline')
        /*setAnimation(anime.timeline({
            targets: ['section.about .date', 'section.about .location'],
            easing: 'cubicBezier(.5, .05, .1, .3)',
            autoplay: false
        })
        .add({
            translateX: [999, 0],
            duration: 800,
            delay: anime.stagger( 100 ),
        })
        )*/
    }, [])
    useEffect( () => {
        /*window.sponsor = sponsors
        window.sponsorshipLevel = sponsorshipLevel
        // console.log('animejs scroll eventListener added')
        window.addEventListener( 'scroll', handleScroll)
        return () => {
            // console.log('animejs scroll eventListener removed')
            window.removeEventListener( 'scroll', handleScroll)
        }*/
    })
    return (
        <section className="about" id="About">
            <div className="containfix">
                
                <div className="grid gridContain">
                    <div className="column grid1">
                        <h1>Wrap-up</h1>
                        <p className="underabout">
                        
                    <a href="https://event.on24.com/eventRegistration/EventLobbyServlet?target=reg30.jsp&referrer=https%3A%2F%2Fwww.fedscoop.com%2Fevents%2Fsnglive%2Fdigital-transformation%2F&eventid=2427959&sessionid=1&key=61045C9646041449804C060FDC949815&regTag=&sourcepage=register" target="_blank" className="pinkify">Watch the On-Demand session</a> from SNG Live: Digital Transformation. Over one hour, we featured candid conversations with IT leaders, across public sector, who shared best practices in digital transformation and described how government leaders can overcome common challenges.<br /><br />
 
 GSA’s Deputy CIO, Beth Killoran, Los Angeles CIO Ted Ross and Cloudera’s President of Government Solutions, Shaun Bierweiler, discussed citizen services modernization.<br /><br />  
  
 Nebraska CIO Ed Toner and the Deputy CIO of the Office of Administration and Strategy at the Department of Labor, Lou Charlier, joined Verizon’s Public Sector CTO Steve Lefrancois to discuss business process re-engineering. <br /><br />
  
 Tennessee CIO Stephanie Dedmond, the USPTO’s Director of the Office of Organization Policy and Governance, Raj Dolas, and Chad Peterson, Solution Engineer at Okta, discussed leading change management at their organization. <br /><br />
  
 Alexander Romero, VMware's End User Computing Technology Strategist, joined Jake Williams, SNG’s Associate Publisher, for a fireside chat on Digital Transformation strategies at VMware. 
                    </p>
                        
                        <p>
                        <a className="regmobwatch" href="https://event.on24.com/eventRegistration/EventLobbyServlet?target=reg30.jsp&referrer=https%3A%2F%2Fwww.fedscoop.com%2Fevents%2Fsnglive%2Fdigital-transformation%2F&eventid=2427959&sessionid=1&key=61045C9646041449804C060FDC949815&regTag=&sourcepage=register" target="_blank">WATCH NOW »</a>
                        </p>
                    </div>
                    <div class="column extra_text">
                        <a className="regworkwatch" href="https://event.on24.com/eventRegistration/EventLobbyServlet?target=reg30.jsp&referrer=https%3A%2F%2Fwww.fedscoop.com%2Fevents%2Fsnglive%2Fdigital-transformation%2F&eventid=2427959&sessionid=1&key=61045C9646041449804C060FDC949815&regTag=&sourcepage=register" target="_blank">WATCH NOW »</a>
                        
                    </div>
                    
                    
                    <div className="column grid3">
                        <div className="grouplogos">
                            <h1>SPONSORS</h1>
                            { sponsorshipLevel ? sponsorshipLevel.map( 
                                ( level, index )  => {
                                    let levelSponsors = sponsors.filter( sponsor => sponsor.level == level && sponsor.event == "jun25")
                                    let levelHasSponsors = levelSponsors.length > 0
                                    return ( 
                                        levelHasSponsors ? <div key={ index }>
                                            
                                            
                                            {levelSponsors.map( (sponsor, key ) => 
                                            <div className="logos">
                                                <a key={key}  href={sponsor.url} title={sponsor.name} target="_blank">
                                                    <img src={sponsor.logo} alt={sponsor.name} width={sponsor.width} />
                                                </a></div>)}
                                            
                                        </div>:
                                        false )
                                })
                                : <em>Missing sponsorshipLevel in gastsby-config.js</em>
                            }

                        </div>
                       
                    </div>
                </div>
            </div>
            <div className="sponsormob-mod" id="Sponsors">
                <div className="grouplogos">
                        <h1>SPONSORS</h1>
                        { sponsorshipLevel ? sponsorshipLevel.map( 
                                ( level, index )  => {
                                    let levelSponsors = sponsors.filter( sponsor => sponsor.level == level  && sponsor.event == "jun25")
                                    let levelHasSponsors = levelSponsors.length > 0
                                    return ( 
                                        levelHasSponsors ? <div key={ index }>
                                            
                                            
                                            {levelSponsors.map( (sponsor, key ) => 
                                            <div className="logos">
                                                <a key={key}  href={sponsor.url} title={sponsor.name} target="_blank">
                                                    <img src={sponsor.logo} alt={sponsor.name} width={sponsor.width} />
                                                </a></div>)}
                                            
                                        </div>:
                                        false )
                                })
                                : <em>Missing sponsorshipLevel in gastsby-config.js</em>
                            }
                </div>
                        </div>
            <div className="sponsormob">
                <div className="containfix">
                    
                    {/*<h2 className="sponsor">BECOME A SPONSOR</h2>
                    <a className="pdf" href="https://s3.amazonaws.com/sng-global-web-assets/sponsors/SNGLIVE_SponsorPackageV2.pdf" target="_blank">DOWNLOAD PDF »</a>
                        <a className="contactus" href="mailto:sales@fedscoop.com" target="_blank">CONTACT US »</a>*/}
                </div>
            </div>
            
        </section>
    )
}

export default FutureAboutWrap